const emailPattern = /^[\w-]+(\.[\w-]+)*@([\w-]+\.)+[a-zA-Z]{2,7}$/;
const passwordPattern = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,}$/;

export function isValidEmail(email) {
    return emailPattern.test(email);
}

export function isValidPassword(password) {
    return passwordPattern.test(password);
}